/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Limited_Cannot_ManageInputs */

const en_disabled_websites_limited_cannot_manage = /** @type {(inputs: Disabled_Websites_Limited_Cannot_ManageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} has limited compatibility. You can only manage it in the "Websites with Limited Compatibility" section.`)
};

const es_disabled_websites_limited_cannot_manage = /** @type {(inputs: Disabled_Websites_Limited_Cannot_ManageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} tiene compatibilidad limitada. Solo puedes administrarlo en la sección "Sitios con compatibilidad limitada".`)
};

/**
* | output |
* | --- |
* | "{hostname} has limited compatibility. You can only manage it in the \"Websites with Limited Compatibility\" section." |
*
* @param {Disabled_Websites_Limited_Cannot_ManageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_limited_cannot_manage = /** @type {((inputs: Disabled_Websites_Limited_Cannot_ManageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Limited_Cannot_ManageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_limited_cannot_manage(inputs)
	return en_disabled_websites_limited_cannot_manage(inputs)
});